// extracted by mini-css-extract-plugin
export default {"smallBanner":"index_smallBanner_lsRne","title":"index_title_1c5I1","line":"index_line_tFksZ"};